import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var StepTransitionToken = /*#__PURE__*/function () {
  function StepTransitionToken() {
    _classCallCheck(this, StepTransitionToken);

    _defineProperty(this, "_allowTransition", true);
  }

  _createClass(StepTransitionToken, [{
    key: "allowTransition",
    get: function get() {
      return this._allowTransition;
    }
  }, {
    key: "preventTransition",
    value: function preventTransition() {
      this._allowTransition = false;
    }
  }]);

  return StepTransitionToken;
}();